import { render, staticRenderFns } from "./SpacerBlock.vue?vue&type=template&id=537c56b5&scoped=true"
import script from "./SpacerBlock.vue?vue&type=script&lang=js"
export * from "./SpacerBlock.vue?vue&type=script&lang=js"
import style0 from "./SpacerBlock.vue?vue&type=style&index=0&id=537c56b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537c56b5",
  null
  
)

export default component.exports